export default __webpack_public_path__ + "static/media/micActive.593991d4.png";